export default __webpack_public_path__ + "assets/img/warningLogo.37474e581bfc09ff1c57ccd7f430b577.png";